  
  


  
  <ng-template #Modal let-data let-ref="dialogRef">
  


    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header>
        {{title}} 
        <div class="row mx-0 mt-3">
          <input  class="col"  [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth 
            shape="rectangle" placeholder="輸入門市名稱">           
          <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
            <i class="fas fa-search"></i>
          </button>  
          
        </div>
        <div class="row mx-0 mt-2 justify-content-between">
          <button class="col-auto  btn" nbButton (click)="onSelectAll()">
            {{status.isSelectAll ? '取消全部' : '選擇全部'}}
          </button>  
          <nb-select class="col-md-5 pr-0" [(ngModel)]="status.showType"  (selectedChange)="onShowType()">
            <nb-option *ngFor="let e of list.showType" [value]="e.value" > {{ e.name }}</nb-option>
          </nb-select>

        
        </div>


      </nb-card-header>
      <nb-card-body>
       
        
         
      
        <div class="">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>選取</th>
                <th>店名</th>
              </tr>
            </thead>
            <tbody *ngIf="showList">
              <tr *ngFor="let item of showList; let j = index">
                <td *ngIf="item.isSelect" (click)="onSelect(false,item)">
                 <button class="btn btn-info py-0 px-1 checkbtn"> <i class="fa fa-check"></i>       </button>          
                </td>
                <td *ngIf="!item.isSelect" (click)="onSelect(true,item)">
                  <button class="btn btn-info py-0 px-1  checkbtn " >    </button>                
                </td>
                <td style="vertical-align: middle;">{{item.StoreName}}</td>
              </tr>

            </tbody>
          </table>
        </div>


        


        
      </nb-card-body>
      <nb-card-footer>
        <button nbButton  class="btn btn-info" (click)="onSave()">確定</button>
        <button nbButton (click)=" ref.close()">關閉</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>